import { css } from '@microsoft/fast-element';
import { MainStyles } from '../../../../main/main.styles';

export const SellerInterestStyles = css`
  ${MainStyles}
  .seller-interest {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .tab-title {
    padding: 2px 4px;
    font-family: 'Roboto-Medium', 'Roboto Medium', 'Roboto', sans-serif;
    font-weight: 500;
    color: var(--white-smoke);
    text-align: left;
    line-height: 15px;
  }

  .filter-rfq-title {
    font-weight: 700;
    color: var(--gray-lighter);
    font-size: 11px;
  }

  .seller-interest-data {
    display: flex;
    height: 100%;
    width: 100%;
  }

  .seller-interest-criteria {
    padding: 16px;
    width: 100%;
  }

  .seller-interest-grid {
    width: calc(100%);
  }

  .seller-interest-select {
    width: 100%;
    min-width: 30px;
  }

  .end-content {
    display: flex;
    align-items: center;
    gap: 5px;
  }

  .rotate-icon::part(start) {
    transform: rotate(180deg);
  }

  zero-grid-pro::part(gridIconButton) {
    background-color: transparent;
  }

  .buttons-padding {
    padding-right: 1px;
    margin-left: 5px;
  }
`;
